define('lib/backbone/Backbone.Mixins.Factory',['require'],function (require) {

  return {
    makeView: function(obj, moduleName, options) {
      return new obj[moduleName](options);
    },

    makeModel: function(obj, moduleName, attributes, options) {
      return new obj[moduleName](attributes, options);
    },

    makeCollection: function(obj, moduleName, models, options) {
      return new obj[moduleName](models, options);
    }
  };

});
